// PushSchalter.jsx — Admin-Push auf diesem Gerät an/aus (Aufgaben 171 + 174, 02.10.2026)
//
// Abo über den Service Worker (/sw.js) und pushManager; der Server schickt
// bei Einwaage nicht bestanden, Einzelstarter, Nachmeldung, Kategorie fertig
// und jeder neuen Anmeldung (backend/services/turnierPushAnlaesse.js).
// localStorage 'tda-push-aktiv' hält den Service Worker auf diesem Gerät am
// Leben (src/index.js meldet ihn sonst bei jedem Laden ab).
import React, { useEffect, useState } from 'react';

const unterstuetzt = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

function schluesselBytes(b64) {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const roh = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...roh].map((c) => c.charCodeAt(0)));
}

export default function PushSchalter() {
  const [an, setAn] = useState(false);
  const [laeuft, setLaeuft] = useState(false);
  const [meldung, setMeldung] = useState('');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token') || ''}` };

  useEffect(() => {
    if (!unterstuetzt()) return;
    navigator.serviceWorker.getRegistration('/sw.js')
      .then((reg) => reg && reg.pushManager.getSubscription())
      .then((abo) => setAn(!!abo))
      .catch(() => {});
  }, []);

  const einschalten = async () => {
    setLaeuft(true); setMeldung('');
    try {
      if (await Notification.requestPermission() !== 'granted') throw new Error('Benachrichtigungen sind im Browser blockiert');
      const r = await fetch('/api/push/schluessel');
      const d = await r.json();
      if (!r.ok || !d.success) throw new Error(d.error || 'Push nicht eingerichtet');
      localStorage.setItem('tda-push-aktiv', '1');
      await navigator.serviceWorker.register('/sw.js');
      const reg = await navigator.serviceWorker.ready; // die AKTIVE Registrierung
      const abo = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: schluesselBytes(d.schluessel) });
      const s = await fetch('/api/push/abo', { method: 'POST', headers, body: JSON.stringify({ abo: abo.toJSON() }) });
      if (!s.ok) throw new Error('Abo nicht gespeichert');
      setAn(true); setMeldung('Push ist an.');
    } catch (e) {
      localStorage.removeItem('tda-push-aktiv');
      setMeldung(e.message);
    } finally { setLaeuft(false); }
  };

  const ausschalten = async () => {
    setLaeuft(true); setMeldung('');
    try {
      const reg = await navigator.serviceWorker.getRegistration('/sw.js');
      const abo = reg && await reg.pushManager.getSubscription();
      if (abo) {
        await fetch('/api/push/abo', { method: 'DELETE', headers, body: JSON.stringify({ endpoint: abo.endpoint }) }).catch(() => {});
        await abo.unsubscribe();
      }
      localStorage.removeItem('tda-push-aktiv');
      setAn(false); setMeldung('Push ist aus.');
    } catch (e) { setMeldung(e.message); }
    finally { setLaeuft(false); }
  };

  const testen = async () => {
    const r = await fetch('/api/push/test', { method: 'POST', headers });
    const d = await r.json().catch(() => ({}));
    setMeldung(r.ok && d.gesendet ? 'Testnachricht verschickt.' : 'Kein Gerät erreicht.');
  };

  if (!unterstuetzt()) return <div className="dropdown-item" style={{ opacity: 0.6, cursor: 'default' }}><span>🔕 Push: von diesem Browser nicht unterstützt</span></div>;
  return (
    <>
      <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); if (!laeuft) (an ? ausschalten() : einschalten()); }}
        title="Nachricht aufs Gerät bei Einwaage nicht bestanden, Einzelstarter, Nachmeldung, Kategorie fertig und neuen Anmeldungen">
        <span>{an ? '🔔 Push auf diesem Gerät: an' : '🔕 Push auf diesem Gerät einschalten'}{laeuft ? ' …' : ''}</span>
      </div>
      {an && <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); testen(); }}><span>📨 Testnachricht senden</span></div>}
      {meldung && <div className="dropdown-item" style={{ cursor: 'default', fontSize: '0.8rem', opacity: 0.8 }} onClick={(e) => e.stopPropagation()}><span>{meldung}</span></div>}
    </>
  );
}
